/* tslint:disable */
/* eslint-disable */
//----------------------
// <auto-generated>
//     Generated using the NSwag toolchain v (http://NSwag.org)
// </auto-generated>
//----------------------
// ReSharper disable InconsistentNaming

export class JwtApiBase {
  AccessToken: Promise<string> | undefined

  protected readonly transformOptions = async (options: RequestInit): Promise<RequestInit> => {
    const token = await this.AccessToken

    options.headers = {
      ...options.headers,
      Authorization: `Bearer ${token}`,
    }

    return options
  }

  // eslint-disable-next-line @typescript-eslint/explicit-module-boundary-types
  public readonly setAccessToken = (token: Promise<string>) => {
    this.AccessToken = token
  }
}

export interface ICompanyDataClientV1 {

    /**
     * Determine whether service is alive
     * @return Service is alive
     */
    ping(): Promise<void>;

    /**
     * Get a list of all companies
     * @param companyNames (optional) company name(s) to filter by
     * @param ssoDomain (optional) SSO Domain to filter by
     * @param includeBinaries (optional) Include binary data in result
     * @return Success
     */
    getCompanies(pageNumber: number, pageSize: number, companyNames: string[] | undefined, ssoDomain: string | undefined, includeBinaries: boolean | undefined): Promise<Company[]>;

    /**
     * Allows creation of a new company.
     * @param body JSON structure that describes company info
     * @return Company successfully created. Company info can be found in response's body
     */
    createCompany(body: CompanyWithoutIdAndDefaultUserGroupId): Promise<Company>;

    /**
     * Returns legacy Id for company
     * @param companyId Id of the company
     * @return Request succeeded. Company id can be found in the body.
     */
    getCompanyLegacyIdById(companyId: string): Promise<number>;

    /**
     * Returns information about company.
     * @param companyId Id of the company
     * @param includeBinaries (optional) Include binary data in result
     * @return Request succeeded. Company info can be found in response's body
     */
    getCompanyById(companyId: string, includeBinaries: boolean | undefined): Promise<Company>;

    /**
     * Updates information about company.
     * @param companyId Id of the company
     * @param body Passed as PUT body
     * @return Request succeeded. Company info updated
     */
    updateCompany(companyId: string, body: CompanyWithoutId): Promise<void>;

    /**
     * Delete a single Company
     * @param companyId Id of the company
     * @return Company successfully deleted.
     */
    deleteCompany(companyId: string): Promise<void>;

    /**
     * Get a list of all companies current user has access to.
     * @param companyNames (optional) company name(s) to filter by
     * @param includeBinaries (optional) Include binary data in result
     * @return Success
     */
    getUserCompanies(pageNumber: number, pageSize: number, companyNames: string[] | undefined, includeBinaries: boolean | undefined): Promise<UserCompany[]>;

    /**
     * Get a list of all regions a company has access to.
     * @param companyId Id of the company
     * @return Success
     */
    getCompanyRegions(companyId: string): Promise<Region[]>;

    /**
     * Get settings for given company
     * @param companyId Company id.
     * @return Company settings can be found in the body of the response.
     */
    getCompanySettings(companyId: string): Promise<CompanySetting[]>;

    /**
     * Create or update settings for a company
     * @param companyId Id of the company.
     * @param body an array of settings to update.
     * @return Setting successfully updated.
     */
    upsertCompanySettings(companyId: string, body: CompanySetting[]): Promise<void>;
}

export class CompanyDataClientV1 extends JwtApiBase implements ICompanyDataClientV1 {
    private http: { fetch(url: RequestInfo, init?: RequestInit): Promise<Response> };
    private baseUrl: string;
    protected jsonParseReviver: ((key: string, value: any) => any) | undefined = undefined;

    constructor(baseUrl?: string, http?: { fetch(url: RequestInfo, init?: RequestInit): Promise<Response> }) {
        super();
        this.http = http ? http : <any>window;
        this.baseUrl = baseUrl !== undefined && baseUrl !== null ? baseUrl : "";
    }

    /**
     * Determine whether service is alive
     * @return Service is alive
     */
    ping(): Promise<void> {
        let url_ = this.baseUrl + "/ping";
        url_ = url_.replace(/[?&]$/, "");

        let options_ = <RequestInit>{
            method: "GET",
            headers: {
            }
        };

        return this.transformOptions(options_).then(transformedOptions_ => {
            return this.http.fetch(url_, transformedOptions_);
        }).then((_response: Response) => {
            return this.processPing(_response);
        });
    }

    protected processPing(response: Response): Promise<void> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 200) {
            return response.text().then((_responseText) => {
            return;
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<void>(<any>null);
    }

    /**
     * Get a list of all companies
     * @param companyNames (optional) company name(s) to filter by
     * @param ssoDomain (optional) SSO Domain to filter by
     * @param includeBinaries (optional) Include binary data in result
     * @return Success
     */
    getCompanies(pageNumber: number, pageSize: number, companyNames: string[] | undefined, ssoDomain: string | undefined, includeBinaries: boolean | undefined): Promise<Company[]> {
        let url_ = this.baseUrl + "/companies?";
        if (pageNumber === undefined || pageNumber === null)
            throw new Error("The parameter 'pageNumber' must be defined and cannot be null.");
        else
            url_ += "pageNumber=" + encodeURIComponent("" + pageNumber) + "&";
        if (pageSize === undefined || pageSize === null)
            throw new Error("The parameter 'pageSize' must be defined and cannot be null.");
        else
            url_ += "pageSize=" + encodeURIComponent("" + pageSize) + "&";
        if (companyNames === null)
            throw new Error("The parameter 'companyNames' cannot be null.");
        else if (companyNames !== undefined)
            companyNames && companyNames.forEach(item => { url_ += "companyNames=" + encodeURIComponent("" + item) + "&"; });
        if (ssoDomain === null)
            throw new Error("The parameter 'ssoDomain' cannot be null.");
        else if (ssoDomain !== undefined)
            url_ += "ssoDomain=" + encodeURIComponent("" + ssoDomain) + "&";
        if (includeBinaries === null)
            throw new Error("The parameter 'includeBinaries' cannot be null.");
        else if (includeBinaries !== undefined)
            url_ += "includeBinaries=" + encodeURIComponent("" + includeBinaries) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_ = <RequestInit>{
            method: "GET",
            headers: {
                "Accept": "application/json"
            }
        };

        return this.transformOptions(options_).then(transformedOptions_ => {
            return this.http.fetch(url_, transformedOptions_);
        }).then((_response: Response) => {
            return this.processGetCompanies(_response);
        });
    }

    protected processGetCompanies(response: Response): Promise<Company[]> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 200) {
            return response.text().then((_responseText) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            if (Array.isArray(resultData200)) {
                result200 = [] as any;
                for (let item of resultData200)
                    result200!.push(Company.fromJS(item));
            }
            else {
                result200 = <any>null;
            }
            return result200;
            });
        } else if (status === 401) {
            return response.text().then((_responseText) => {
            return throwException("You must be authenticated.", status, _responseText, _headers);
            });
        } else if (status === 403) {
            return response.text().then((_responseText) => {
            return throwException("You do not have sufficient permissions to perform this action.", status, _responseText, _headers);
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<Company[]>(<any>null);
    }

    /**
     * Allows creation of a new company.
     * @param body JSON structure that describes company info
     * @return Company successfully created. Company info can be found in response's body
     */
    createCompany(body: CompanyWithoutIdAndDefaultUserGroupId): Promise<Company> {
        let url_ = this.baseUrl + "/companies";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(body);

        let options_ = <RequestInit>{
            body: content_,
            method: "POST",
            headers: {
                "Content-Type": "application/json",
                "Accept": "application/json"
            }
        };

        return this.transformOptions(options_).then(transformedOptions_ => {
            return this.http.fetch(url_, transformedOptions_);
        }).then((_response: Response) => {
            return this.processCreateCompany(_response);
        });
    }

    protected processCreateCompany(response: Response): Promise<Company> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 201) {
            return response.text().then((_responseText) => {
            let result201: any = null;
            let resultData201 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result201 = Company.fromJS(resultData201);
            return result201;
            });
        } else if (status === 400) {
            return response.text().then((_responseText) => {
            return throwException("Model is invalid", status, _responseText, _headers);
            });
        } else if (status === 401) {
            return response.text().then((_responseText) => {
            return throwException("You must be authenticated.", status, _responseText, _headers);
            });
        } else if (status === 403) {
            return response.text().then((_responseText) => {
            return throwException("You do not have sufficient permissions to perform this action.", status, _responseText, _headers);
            });
        } else if (status === 409) {
            return response.text().then((_responseText) => {
            return throwException("Company with specified CompanyName already exists", status, _responseText, _headers);
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<Company>(<any>null);
    }

    /**
     * Returns legacy Id for company
     * @param companyId Id of the company
     * @return Request succeeded. Company id can be found in the body.
     */
    getCompanyLegacyIdById(companyId: string): Promise<number> {
        let url_ = this.baseUrl + "/companies/{companyId}/legacy-id";
        if (companyId === undefined || companyId === null)
            throw new Error("The parameter 'companyId' must be defined.");
        url_ = url_.replace("{companyId}", encodeURIComponent("" + companyId));
        url_ = url_.replace(/[?&]$/, "");

        let options_ = <RequestInit>{
            method: "GET",
            headers: {
                "Accept": "application/json"
            }
        };

        return this.transformOptions(options_).then(transformedOptions_ => {
            return this.http.fetch(url_, transformedOptions_);
        }).then((_response: Response) => {
            return this.processGetCompanyLegacyIdById(_response);
        });
    }

    protected processGetCompanyLegacyIdById(response: Response): Promise<number> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 200) {
            return response.text().then((_responseText) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
                result200 = resultData200 !== undefined ? resultData200 : <any>null;
    
            return result200;
            });
        } else if (status === 401) {
            return response.text().then((_responseText) => {
            return throwException("You must be authenticated.", status, _responseText, _headers);
            });
        } else if (status === 404) {
            return response.text().then((_responseText) => {
            return throwException("No Company found for given id.", status, _responseText, _headers);
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<number>(<any>null);
    }

    /**
     * Returns information about company.
     * @param companyId Id of the company
     * @param includeBinaries (optional) Include binary data in result
     * @return Request succeeded. Company info can be found in response's body
     */
    getCompanyById(companyId: string, includeBinaries: boolean | undefined): Promise<Company> {
        let url_ = this.baseUrl + "/companies/{companyId}?";
        if (companyId === undefined || companyId === null)
            throw new Error("The parameter 'companyId' must be defined.");
        url_ = url_.replace("{companyId}", encodeURIComponent("" + companyId));
        if (includeBinaries === null)
            throw new Error("The parameter 'includeBinaries' cannot be null.");
        else if (includeBinaries !== undefined)
            url_ += "includeBinaries=" + encodeURIComponent("" + includeBinaries) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_ = <RequestInit>{
            method: "GET",
            headers: {
                "Accept": "application/json"
            }
        };

        return this.transformOptions(options_).then(transformedOptions_ => {
            return this.http.fetch(url_, transformedOptions_);
        }).then((_response: Response) => {
            return this.processGetCompanyById(_response);
        });
    }

    protected processGetCompanyById(response: Response): Promise<Company> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 200) {
            return response.text().then((_responseText) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = Company.fromJS(resultData200);
            return result200;
            });
        } else if (status === 401) {
            return response.text().then((_responseText) => {
            return throwException("You must be authenticated.", status, _responseText, _headers);
            });
        } else if (status === 404) {
            return response.text().then((_responseText) => {
            return throwException("No Company found for given id.", status, _responseText, _headers);
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<Company>(<any>null);
    }

    /**
     * Updates information about company.
     * @param companyId Id of the company
     * @param body Passed as PUT body
     * @return Request succeeded. Company info updated
     */
    updateCompany(companyId: string, body: CompanyWithoutId): Promise<void> {
        let url_ = this.baseUrl + "/companies/{companyId}";
        if (companyId === undefined || companyId === null)
            throw new Error("The parameter 'companyId' must be defined.");
        url_ = url_.replace("{companyId}", encodeURIComponent("" + companyId));
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(body);

        let options_ = <RequestInit>{
            body: content_,
            method: "PUT",
            headers: {
                "Content-Type": "application/json",
            }
        };

        return this.transformOptions(options_).then(transformedOptions_ => {
            return this.http.fetch(url_, transformedOptions_);
        }).then((_response: Response) => {
            return this.processUpdateCompany(_response);
        });
    }

    protected processUpdateCompany(response: Response): Promise<void> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 204) {
            return response.text().then((_responseText) => {
            return;
            });
        } else if (status === 401) {
            return response.text().then((_responseText) => {
            return throwException("You must be authenticated.", status, _responseText, _headers);
            });
        } else if (status === 500) {
            return response.text().then((_responseText) => {
            return throwException("Failed to find a company in the database with a given identifier", status, _responseText, _headers);
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<void>(<any>null);
    }

    /**
     * Delete a single Company
     * @param companyId Id of the company
     * @return Company successfully deleted.
     */
    deleteCompany(companyId: string): Promise<void> {
        let url_ = this.baseUrl + "/companies/{companyId}";
        if (companyId === undefined || companyId === null)
            throw new Error("The parameter 'companyId' must be defined.");
        url_ = url_.replace("{companyId}", encodeURIComponent("" + companyId));
        url_ = url_.replace(/[?&]$/, "");

        let options_ = <RequestInit>{
            method: "DELETE",
            headers: {
            }
        };

        return this.transformOptions(options_).then(transformedOptions_ => {
            return this.http.fetch(url_, transformedOptions_);
        }).then((_response: Response) => {
            return this.processDeleteCompany(_response);
        });
    }

    protected processDeleteCompany(response: Response): Promise<void> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 204) {
            return response.text().then((_responseText) => {
            return;
            });
        } else if (status === 400) {
            return response.text().then((_responseText) => {
            return throwException("Bad Request. Failed to parse Company identifier", status, _responseText, _headers);
            });
        } else if (status === 401) {
            return response.text().then((_responseText) => {
            return throwException("You must be authenticated.", status, _responseText, _headers);
            });
        } else if (status === 403) {
            return response.text().then((_responseText) => {
            return throwException("You do not have sufficient permissions to perform this action.", status, _responseText, _headers);
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<void>(<any>null);
    }

    /**
     * Get a list of all companies current user has access to.
     * @param companyNames (optional) company name(s) to filter by
     * @param includeBinaries (optional) Include binary data in result
     * @return Success
     */
    getUserCompanies(pageNumber: number, pageSize: number, companyNames: string[] | undefined, includeBinaries: boolean | undefined): Promise<UserCompany[]> {
        let url_ = this.baseUrl + "/users/me/companies?";
        if (pageNumber === undefined || pageNumber === null)
            throw new Error("The parameter 'pageNumber' must be defined and cannot be null.");
        else
            url_ += "pageNumber=" + encodeURIComponent("" + pageNumber) + "&";
        if (pageSize === undefined || pageSize === null)
            throw new Error("The parameter 'pageSize' must be defined and cannot be null.");
        else
            url_ += "pageSize=" + encodeURIComponent("" + pageSize) + "&";
        if (companyNames === null)
            throw new Error("The parameter 'companyNames' cannot be null.");
        else if (companyNames !== undefined)
            companyNames && companyNames.forEach(item => { url_ += "companyNames=" + encodeURIComponent("" + item) + "&"; });
        if (includeBinaries === null)
            throw new Error("The parameter 'includeBinaries' cannot be null.");
        else if (includeBinaries !== undefined)
            url_ += "includeBinaries=" + encodeURIComponent("" + includeBinaries) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_ = <RequestInit>{
            method: "GET",
            headers: {
                "Accept": "application/json"
            }
        };

        return this.transformOptions(options_).then(transformedOptions_ => {
            return this.http.fetch(url_, transformedOptions_);
        }).then((_response: Response) => {
            return this.processGetUserCompanies(_response);
        });
    }

    protected processGetUserCompanies(response: Response): Promise<UserCompany[]> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 200) {
            return response.text().then((_responseText) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            if (Array.isArray(resultData200)) {
                result200 = [] as any;
                for (let item of resultData200)
                    result200!.push(UserCompany.fromJS(item));
            }
            else {
                result200 = <any>null;
            }
            return result200;
            });
        } else if (status === 401) {
            return response.text().then((_responseText) => {
            return throwException("You must be authenticated.", status, _responseText, _headers);
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<UserCompany[]>(<any>null);
    }

    /**
     * Get a list of all regions a company has access to.
     * @param companyId Id of the company
     * @return Success
     */
    getCompanyRegions(companyId: string): Promise<Region[]> {
        let url_ = this.baseUrl + "/companies/{companyId}/regions";
        if (companyId === undefined || companyId === null)
            throw new Error("The parameter 'companyId' must be defined.");
        url_ = url_.replace("{companyId}", encodeURIComponent("" + companyId));
        url_ = url_.replace(/[?&]$/, "");

        let options_ = <RequestInit>{
            method: "GET",
            headers: {
                "Accept": "application/json"
            }
        };

        return this.transformOptions(options_).then(transformedOptions_ => {
            return this.http.fetch(url_, transformedOptions_);
        }).then((_response: Response) => {
            return this.processGetCompanyRegions(_response);
        });
    }

    protected processGetCompanyRegions(response: Response): Promise<Region[]> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 200) {
            return response.text().then((_responseText) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            if (Array.isArray(resultData200)) {
                result200 = [] as any;
                for (let item of resultData200)
                    result200!.push(Region.fromJS(item));
            }
            else {
                result200 = <any>null;
            }
            return result200;
            });
        } else if (status === 401) {
            return response.text().then((_responseText) => {
            return throwException("You must be authenticated.", status, _responseText, _headers);
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<Region[]>(<any>null);
    }

    /**
     * Get settings for given company
     * @param companyId Company id.
     * @return Company settings can be found in the body of the response.
     */
    getCompanySettings(companyId: string): Promise<CompanySetting[]> {
        let url_ = this.baseUrl + "/companies/{companyId}/settings";
        if (companyId === undefined || companyId === null)
            throw new Error("The parameter 'companyId' must be defined.");
        url_ = url_.replace("{companyId}", encodeURIComponent("" + companyId));
        url_ = url_.replace(/[?&]$/, "");

        let options_ = <RequestInit>{
            method: "GET",
            headers: {
                "Accept": "application/json"
            }
        };

        return this.transformOptions(options_).then(transformedOptions_ => {
            return this.http.fetch(url_, transformedOptions_);
        }).then((_response: Response) => {
            return this.processGetCompanySettings(_response);
        });
    }

    protected processGetCompanySettings(response: Response): Promise<CompanySetting[]> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 200) {
            return response.text().then((_responseText) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            if (Array.isArray(resultData200)) {
                result200 = [] as any;
                for (let item of resultData200)
                    result200!.push(CompanySetting.fromJS(item));
            }
            else {
                result200 = <any>null;
            }
            return result200;
            });
        } else if (status === 401) {
            return response.text().then((_responseText) => {
            return throwException("You must be authenticated.", status, _responseText, _headers);
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<CompanySetting[]>(<any>null);
    }

    /**
     * Create or update settings for a company
     * @param companyId Id of the company.
     * @param body an array of settings to update.
     * @return Setting successfully updated.
     */
    upsertCompanySettings(companyId: string, body: CompanySetting[]): Promise<void> {
        let url_ = this.baseUrl + "/companies/{companyId}/settings";
        if (companyId === undefined || companyId === null)
            throw new Error("The parameter 'companyId' must be defined.");
        url_ = url_.replace("{companyId}", encodeURIComponent("" + companyId));
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(body);

        let options_ = <RequestInit>{
            body: content_,
            method: "PUT",
            headers: {
                "Content-Type": "application/json",
            }
        };

        return this.transformOptions(options_).then(transformedOptions_ => {
            return this.http.fetch(url_, transformedOptions_);
        }).then((_response: Response) => {
            return this.processUpsertCompanySettings(_response);
        });
    }

    protected processUpsertCompanySettings(response: Response): Promise<void> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 204) {
            return response.text().then((_responseText) => {
            return;
            });
        } else if (status === 401) {
            return response.text().then((_responseText) => {
            return throwException("You must be authenticated.", status, _responseText, _headers);
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<void>(<any>null);
    }
}

export class CompanyWithoutIdAndDefaultUserGroupId implements ICompanyWithoutIdAndDefaultUserGroupId {
    companyName!: string;
    companyIconURL?: string | undefined;
    headerIconURL?: string | undefined;
    showroomRoomId?: string | undefined;
    logo1024X1024?: string | undefined;
    logo256X256?: string | undefined;
    isPartnerCompany!: boolean;
    isVisibleToExternalUsers?: boolean;
    friendlyName!: string;
    sSODomain?: string;

    constructor(data?: ICompanyWithoutIdAndDefaultUserGroupId) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property) && this.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
        if (!data) {
            this.isPartnerCompany = false;
            this.isVisibleToExternalUsers = true;
        }
    }

    init(_data?: any) {
        if (_data) {
            this.companyName = _data["CompanyName"];
            this.companyIconURL = _data["CompanyIconURL"];
            this.headerIconURL = _data["HeaderIconURL"];
            this.showroomRoomId = _data["ShowroomRoomId"];
            this.logo1024X1024 = _data["Logo1024X1024"];
            this.logo256X256 = _data["Logo256X256"];
            this.isPartnerCompany = _data["IsPartnerCompany"] !== undefined ? _data["IsPartnerCompany"] : false;
            this.isVisibleToExternalUsers = _data["IsVisibleToExternalUsers"] !== undefined ? _data["IsVisibleToExternalUsers"] : true;
            this.friendlyName = _data["FriendlyName"];
            this.sSODomain = _data["SSODomain"];
        }
    }

    static fromJS(data: any): CompanyWithoutIdAndDefaultUserGroupId {
        data = typeof data === 'object' ? data : {};
        let result = new CompanyWithoutIdAndDefaultUserGroupId();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["CompanyName"] = this.companyName;
        data["CompanyIconURL"] = this.companyIconURL;
        data["HeaderIconURL"] = this.headerIconURL;
        data["ShowroomRoomId"] = this.showroomRoomId;
        data["Logo1024X1024"] = this.logo1024X1024;
        data["Logo256X256"] = this.logo256X256;
        data["IsPartnerCompany"] = this.isPartnerCompany;
        data["IsVisibleToExternalUsers"] = this.isVisibleToExternalUsers;
        data["FriendlyName"] = this.friendlyName;
        data["SSODomain"] = this.sSODomain;
        return data;
    }
}

export interface ICompanyWithoutIdAndDefaultUserGroupId {
    companyName: string;
    companyIconURL?: string | undefined;
    headerIconURL?: string | undefined;
    showroomRoomId?: string | undefined;
    logo1024X1024?: string | undefined;
    logo256X256?: string | undefined;
    isPartnerCompany: boolean;
    isVisibleToExternalUsers?: boolean;
    friendlyName: string;
    sSODomain?: string;
}

export class CompanyWithoutId extends CompanyWithoutIdAndDefaultUserGroupId implements ICompanyWithoutId {
    defaultUserGroupId!: string;

    constructor(data?: ICompanyWithoutId) {
        super(data);
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property) && this.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        super.init(_data);
        if (_data) {
            this.defaultUserGroupId = _data["DefaultUserGroupId"];
        }
    }

    static fromJS(data: any): CompanyWithoutId {
        data = typeof data === 'object' ? data : {};
        let result = new CompanyWithoutId();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["DefaultUserGroupId"] = this.defaultUserGroupId;
        super.toJSON(data);
        return data;
    }
}

export interface ICompanyWithoutId extends ICompanyWithoutIdAndDefaultUserGroupId {
    defaultUserGroupId: string;
}

export class Company extends CompanyWithoutId implements ICompany {
    companyId!: string;

    constructor(data?: ICompany) {
        super(data);
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property) && this.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        super.init(_data);
        if (_data) {
            this.companyId = _data["CompanyId"];
        }
    }

    static fromJS(data: any): Company {
        data = typeof data === 'object' ? data : {};
        let result = new Company();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["CompanyId"] = this.companyId;
        super.toJSON(data);
        return data;
    }
}

export interface ICompany extends ICompanyWithoutId {
    companyId: string;
}

export class UserCompany extends Company implements IUserCompany {
    hasContentAccess!: boolean;

    constructor(data?: IUserCompany) {
        super(data);
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property) && this.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
        if (!data) {
            this.hasContentAccess = false;
        }
    }

    init(_data?: any) {
        super.init(_data);
        if (_data) {
            this.hasContentAccess = _data["HasContentAccess"] !== undefined ? _data["HasContentAccess"] : false;
        }
    }

    static fromJS(data: any): UserCompany {
        data = typeof data === 'object' ? data : {};
        let result = new UserCompany();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["HasContentAccess"] = this.hasContentAccess;
        super.toJSON(data);
        return data;
    }
}

export interface IUserCompany extends ICompany {
    hasContentAccess: boolean;
}

export class Region implements IRegion {
    prefix?: string;
    friendlyName!: string;
    isDefault?: boolean;

    constructor(data?: IRegion) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property) && this.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
        if (!data) {
            this.isDefault = false;
        }
    }

    init(_data?: any) {
        if (_data) {
            this.prefix = _data["Prefix"];
            this.friendlyName = _data["FriendlyName"];
            this.isDefault = _data["IsDefault"] !== undefined ? _data["IsDefault"] : false;
        }
    }

    static fromJS(data: any): Region {
        data = typeof data === 'object' ? data : {};
        let result = new Region();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["Prefix"] = this.prefix;
        data["FriendlyName"] = this.friendlyName;
        data["IsDefault"] = this.isDefault;
        return data;
    }
}

export interface IRegion {
    prefix?: string;
    friendlyName: string;
    isDefault?: boolean;
}

export class CompanySetting implements ICompanySetting {
    settingKey!: string;
    settingValue!: string;

    constructor(data?: ICompanySetting) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property) && this.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.settingKey = _data["SettingKey"];
            this.settingValue = _data["SettingValue"];
        }
    }

    static fromJS(data: any): CompanySetting {
        data = typeof data === 'object' ? data : {};
        let result = new CompanySetting();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["SettingKey"] = this.settingKey;
        data["SettingValue"] = this.settingValue;
        return data;
    }
}

export interface ICompanySetting {
    settingKey: string;
    settingValue: string;
}

export class ApiException extends Error {
    message: string;
    status: number;
    response: string;
    headers: { [key: string]: any; };
    result: any;

    constructor(message: string, status: number, response: string, headers: { [key: string]: any; }, result: any) {
        super();

        this.message = message;
        this.status = status;
        this.response = response;
        this.headers = headers;
        this.result = result;
    }

    protected isApiException = true;

    static isApiException(obj: any): obj is ApiException {
        return obj.isApiException === true;
    }
}

function throwException(message: string, status: number, response: string, headers: { [key: string]: any; }, result?: any): any {
    if (result !== null && result !== undefined)
        throw result;
    else
        throw new ApiException(message, status, response, headers, null);
}

/* tslint:disable */
/* eslint-disable */